export default "__VITE_ASSET__O8oU1J8A__"